import './address-quality/address-quality.component';
import './address-quality/address-quality.scss';

import './address-resolver-edit-form/address-resolver-edit-form.component';
import './address-resolver-edit-form/address-resolver-edit-form.scss';

import './address-resolver-map/address-resolver-map.component';
import './address-resolver-map/address-resolver-map.scss';

import './addresses-resolver-edit-view/addresses-resolver-edit-view.component';
import './addresses-resolver-edit-view/addresses-resolver-edit-view.scss';

import './addresses-resolver-list/addresses-resolver-list.component';
import './addresses-resolver-list/addresses-resolver-list.scss';

import './addresses-resolver-list-item/addresses-resolver-list-item.component';
import './addresses-resolver-list-item/addresses-resolver-list-item.scss';

import './addresses-resolver-view/addresses-resolver-view.component';
import './addresses-resolver-view/addresses-resolver-view.scss';

import './address-form/address-form.component';
import './address-form/address-form.scss';

import './map-address-autocomplete/map-address-autocomplete.component';
import './map-address-autocomplete/map-address-autocomplete.scss';

import './address-quality-multi-select-list/address-quality-multi-select-list.component';
import './address-quality-multi-select-list/address-quality-multi-select-list.scss';

import './address-qualities-display-list/address-qualities-display-list.component';
import './address-qualities-display-list/address-qualities-display-list.scss';
